const parseRestaurantId = (value) => {
  const parsed = Number.parseInt(value, 10);
  return Number.isInteger(parsed) && parsed > 0 ? parsed : null;
};

export const getStoredRestaurantId = () => {
  if (typeof window === 'undefined') {
    return null;
  }

  return parseRestaurantId(localStorage.getItem('selected_restaurant_id'));
};

export const getEffectiveRestaurantId = (user = null, pathname = '') => {
  const userRestaurantId = parseRestaurantId(user?.restaurant_id);
  if (userRestaurantId) {
    return userRestaurantId;
  }

  const currentPath = pathname || (typeof window !== 'undefined' ? window.location.pathname : '');
  if (currentPath.toLowerCase().startsWith('/lakehouse')) {
    return 2;
  }

  if (typeof window !== 'undefined') {
    const queryRestaurantId = parseRestaurantId(new URLSearchParams(window.location.search).get('restaurant_id'));
    if (queryRestaurantId) {
      return queryRestaurantId;
    }
  }

  const storedRestaurantId = getStoredRestaurantId();
  if (storedRestaurantId) {
    return storedRestaurantId;
  }

  return 1;
};

export const isLakehouseContext = (user = null, pathname = '') => {
  return getEffectiveRestaurantId(user, pathname) === 2;
};
